import { render, staticRenderFns } from "./UrlWhitelistingWidget.vue?vue&type=template&id=d792efd2"
import script from "./UrlWhitelistingWidget.vue?vue&type=script&lang=js"
export * from "./UrlWhitelistingWidget.vue?vue&type=script&lang=js"
import style0 from "./UrlWhitelistingWidget.vue?vue&type=style&index=0&id=d792efd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports